import stateConst from './const';

export default {
  auth: localStorage.auth ? JSON.parse(localStorage.auth) : stateConst.DEFAULT_AUTH,
  authErrors: null,
  authErrorCode: null,
};
